export default __webpack_public_path__ + "static/media/promo_video.a2df4fdb.mp4";